import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  DISPATCH_BOARD_LIST_REQUEST,
  DISPATCH_BOARD_DATA_REQUEST,
  DISPATCH_BOARD_CREATE_REQUEST,
  DISPATCH_BOARD_UPDATE_REQUEST,
  DISPATCH_BOARD_DELETE_REQUEST,
} from "./actionType";
import {
  listDispatchBoardsSuccess,
  listDispatchBoardsFail,
  getDispatchBoardSuccess,
  getDispatchBoardFail,
  createDispatchBoardSuccess,
  createDispatchBoardFail,
  updateDispatchBoardSuccess,
  updateDispatchBoardFail,
  deleteDispatchBoardSuccess,
  deleteDispatchBoardFail,
} from "./action";
import {
  dispatchBoardListApi,
  dispatchBoardDataApi,
  dispatchBoardCreateApi,
  dispatchBoardUpdateApi,
  dispatchBoardDeleteApi,
} from "../../helpers/fakebackend_helper";

function* listDispatchBoardsSaga() {
  try {
    const response = yield call(dispatchBoardListApi);
    yield put(listDispatchBoardsSuccess(response));
  } catch (error) {
    yield put(listDispatchBoardsFail(error));
  }
}

function* getDispatchBoardSaga({ payload }) {
  try {
    const response = yield call(dispatchBoardDataApi, payload);
    yield put(getDispatchBoardSuccess(response));
  } catch (error) {
    yield put(getDispatchBoardFail(error));
  }
}

function* createDispatchBoardSaga({ payload }) {
  try {
    const response = yield call(dispatchBoardCreateApi, payload);
    yield put(createDispatchBoardSuccess(response));
  } catch (error) {
    yield put(createDispatchBoardFail(error));
  }
}

function* updateDispatchBoardSaga({ payload }) {
  try {
    const response = yield call(dispatchBoardUpdateApi, payload);
    yield put(updateDispatchBoardSuccess(response));
  } catch (error) {
    yield put(updateDispatchBoardFail(error));
  }
}

function* deleteDispatchBoardSaga({ payload }) {
  try {
    const response = yield call(dispatchBoardDeleteApi, payload);
    yield put(deleteDispatchBoardSuccess(response));
  } catch (error) {
    yield put(deleteDispatchBoardFail(error));
  }
}

export default function* DispatchBoardSaga() {
  yield all([
    takeLatest(DISPATCH_BOARD_LIST_REQUEST, listDispatchBoardsSaga),
    takeLatest(DISPATCH_BOARD_DATA_REQUEST, getDispatchBoardSaga),
    takeLatest(DISPATCH_BOARD_CREATE_REQUEST, createDispatchBoardSaga),
    takeLatest(DISPATCH_BOARD_UPDATE_REQUEST, updateDispatchBoardSaga),
    takeLatest(DISPATCH_BOARD_DELETE_REQUEST, deleteDispatchBoardSaga),
  ]);
}
